import { render, staticRenderFns } from "./jobInformation4.vue?vue&type=template&id=0a389d1a&scoped=true"
import script from "./jobInformation4.vue?vue&type=script&lang=js"
export * from "./jobInformation4.vue?vue&type=script&lang=js"
import style0 from "./jobInformation4.vue?vue&type=style&index=0&id=0a389d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a389d1a",
  null
  
)

export default component.exports